import { generateText } from "@tiptap/core";
import { ReactComponent as ArrowRight } from "../../Assets/angle-right-solid.svg";
import { Article } from "../../Stores/News";
import { useRouterStore } from "../../Stores/Router";
import "./NewsCard.scss";
import { ExtensionKit } from "../tiptap/extenstions/extension-kit";

function NewsCard({ news }: { news: Article }) {
  const routerStore = useRouterStore();

  if (!news) {
    return null;
  }

  var previewText = "";
  try {
    if (news.message) {
      previewText = generateText(news.message, [...ExtensionKit({})]);
    }
  } catch (error) {
    console.log(error);
  }

  return (
    <div
      className="news-card"
      onClick={() => {
        routerStore.pushPage("newsdetails", { id: news.id });
      }}
    >
      {news.coverImageUrl && news.coverImageUrl.length > 0 && (
        <img className="news-card-image" src={news.coverImageUrl} />
      )}
      <div className="news-card-content">
        <div className="news-card-content-content">
          <div className="news-card-content-title">
            {news?.config?.pinned && "📌 "}
            {news.subject}
          </div>
          <div className="news-card-content-meta">{previewText}</div>
        </div>
        <ArrowRight className="news-card-content-show-details" />
      </div>
    </div>
  );
}

export default NewsCard;
